import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'

import { IChangeVehicleStatusForm } from 'features/Vehicles/types'

const newStatusMessages = defineMessages({
  required: {
    id: 'vehicles.changeStatus.newStatus.required',
    defaultMessage: 'You need to select the status'
  }
})

const reasonMessages = defineMessages({
  required: {
    id: 'vehicles.changeStatus.reason.required',
    defaultMessage: 'The reason is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IChangeVehicleStatusForm> => {
  return yup.object().shape({
    status: yup.mixed().required(intl.formatMessage(newStatusMessages.required)),
    reason: yup.mixed().when('status', {
      is: 'DEACTIVATED',
      then: yup.mixed().required(intl.formatMessage(reasonMessages.required))
    })
  })
}
